module.exports = __webpack_public_path__ + "static/media/bellabyte-logo-branding-01.1c9a7bb3.jpg";